






























































































































































































































































































































































































































































































































































import {Component, Mixins, Prop, Watch} from 'vue-property-decorator';
import {SelectBox} from '@/interfaces/global-data';
import {
  GetTaskInfo,
  TaskData,
  TaskInfoFilterType,
  TaskParams,
  TaskStatus,
  TaskType,
} from '@/interfaces/server-data';
import {localizeTaskType, localizeTaskStatus} from '@/utils/backendValueLocalizer';
import Http from '@/mixins/http';
import LocalData from '@/mixins/local-data';
import Toast from '@/mixins/toast';
import TaskStatusMixin from '@/mixins/task-status';
import Card from '@/components/UI/Card.vue';
import DatePicker from '@/components/UI/DatePicker.vue';
import 'vue2-datepicker/index.css';

@Component({
    components: {
        Card,
        DatePicker,
    },
})
export default class CalcQueue extends Mixins(LocalData, Toast, Http, TaskStatusMixin) {
    @Prop({ type: Boolean, default: false }) active!: boolean;

    defaultIntSelectBox: Array<SelectBox<number>> = [{value: -1, label: this.$t('regular.common.all') as string}];
    taskIdFilter: string | null = null;
    taskIdFilterEdit: string | null = null;
    taskNoteFilter: string | null = null;
    taskNoteFilterEdit: string | null = null;
    allReportsIds: number[] = [];
    isAllReportsSelected: boolean = false;
    selectedReportsArray: number[] = [];
    updatedDateRange: string[] = [];
    updatedDateRangeEdit: string[] = [];
    defaultFilterValue = {value: -1, label: this.$t('regular.common.all') as string};
    secondDefaultFilterValue = {value: -2, label: this.$t('regular.common.notSelected') as string};
    defaultMultipleValue = [this.defaultFilterValue, this.secondDefaultFilterValue];

    selectMarket: number = this.defaultFilterValue.value;
    selectMarketEdit: number = this.defaultFilterValue.value;
    items: Array<SelectBox<number>> = [];

    categoryOptions: Array<SelectBox<number>> = [];
    categoryOfProduct: number = this.defaultFilterValue.value;
    categoryOfProductEdit: number = this.defaultFilterValue.value;

    subCategoryOptions: Array<SelectBox<number>> = this.defaultMultipleValue;
    subCategoryOfProduct: number[] = [];
    subCategoryOfProductEdit: number[] = [];

    selectGroup: number = this.defaultFilterValue.value;
    selectGroupEdit: number = this.defaultFilterValue.value;
    groupOptions: Array<SelectBox<number>> = this.defaultMultipleValue;

    selectFormat: number = this.defaultFilterValue.value;
    selectFormatEdit: number = this.defaultFilterValue.value;
    formatOptions: Array<SelectBox<number>> = this.defaultMultipleValue;

    selectRegion: number[] = [];
    selectRegionEdit: number[] = [];
    regionOptions: Array<SelectBox<number>> = this.defaultMultipleValue;

    selectCluster: number = this.defaultFilterValue.value;
    selectClusterEdit: number = this.defaultFilterValue.value;
    clusterOptions: Array<SelectBox<number>> = this.defaultMultipleValue;

    selectReportType: TaskType | null = null;
    selectReportTypeEdit: TaskType | null = null;
    usersFioList: Array<SelectBox<string>> = [];
    selectUserFio: string = 'All';
    selectUserFioEdit: string = 'All';

    table: TaskData[] = [];
    refreshTableTimeoutId?: number;
    isTableLoading: boolean = false;

    reportList: Array<SelectBox<TaskType | null>> = [
        {value: null, label: this.$t('regular.common.all') as string},
        {value: TaskType.REGULAR, label: this.$t('regular.taskTypes.regular') as string},
        {value: TaskType.PACKAGE_REGULAR, label: this.$t('regular.taskTypes.package') as string},
        {value: TaskType.PACKAGE_GENERAL, label: this.$t('regular.taskTypes.packageGeneral') as string},
        {value: TaskType.PACKAGE_GENERAL_KVI_CARTS, label: this.$t('regular.taskTypes.packageByBasket') as string},
        {value: TaskType.PACKAGE_GENERAL_KVI_RECOMMENDS, label: this.$t('regular.taskTypes.packageKviSearch') as string},
        {value: TaskType.PACKAGE_SALES, label: this.$t('regular.taskTypes.packageSales') as string},
        {value: TaskType.PACKAGE_GENERAL_SALES, label: this.$t('regular.taskTypes.packageGeneralSales') as string},
        {value: TaskType.PACKAGE_PROMOTION, label: this.$t('regular.taskTypes.packagePromotion') as string},
        {value: TaskType.PACKAGE_GENERAL_PROMOTION, label: this.$t('regular.taskTypes.packageGeneralPromotion') as string},
        {value: TaskType.PACKAGE_SCHEDULE, label: this.$t('regular.taskTypes.scheduled') as string},
        {value: TaskType.BRUT_FORCE, label: this.$t('regular.statuses.paramSearch') as string},
        {value: TaskType.SEARCH_KVI, label: this.$t('regular.taskTypes.kviSearch') as string},
        {value: TaskType.PROMO, label: this.$t('regular.columns.promo') as string},
        {value: TaskType.PACKAGE_EVENTS, label: this.$t('regular.taskTypes.eventCalc') as string},
        {value: TaskType.PACKAGE_EVENTS_GENERAL, label: this.$t('regular.taskTypes.eventCalcGeneral') as string},
        {value: TaskType.PACKAGE_PROMO_GENERAL_RECOMMENDS, label: this.$t('regular.columns.promoRecommendations') as string},
        {value: TaskType.PACKAGE_SCENARIO, label: this.$t('regular.taskTypes.scenario') as string},
        {value: TaskType.PACKAGE_FIXED_PRICE, label: this.$t('regular.taskTypes.packageFixed') as string},
        {value: TaskType.PACKAGE_GENERAL_FIXED_PRICE, label: this.$t('regular.taskTypes.packageGeneralFixed') as string},
        {value: TaskType.REGULAR_PRICE_EXP, label: this.$t('regular.taskTypes.regularCe') as string},
        {value: TaskType.SCHEDULED_PRICE_EXP, label: this.$t('regular.taskTypes.scheduledCe') as string},
    ];

    selectStatus: TaskStatus | null = null;
    selectStatusEdit: TaskStatus | null = null;
    statusList: Array<SelectBox<TaskStatus | null>> = [
        {value: null, label: this.$t('regular.common.all') as string},
        {value: TaskStatus.ARITHMETICEXCEPTION, label: this.$t('regular.columns.arithmeticError') as string},
        {value: TaskStatus.INQUEUE, label: this.$t('regular.statuses.inQueue') as string},
        {value: TaskStatus.WRITETOFILE, label: this.$t('regular.statuses.writingToFile') as string},
        {value: TaskStatus.CALCULATING, label: this.$t('regular.statuses.calculating') as string},
        {value: TaskStatus.ONAPPROVAL, label: this.$t('regular.statuses.pendingApproval') as string},
        {value: TaskStatus.EMPTYDATA, label: this.$t('regular.statuses.noDataForSelection') as string},
        {value: TaskStatus.RESTARTERROR, label: this.$t('regular.statuses.stopped') as string},
        {value: TaskStatus.REJECTED, label: this.$t('regular.statuses.rejected') as string},
        {value: TaskStatus.PARTIALLY_REJECTED, label: this.$t('regular.statuses.partiallyRejected') as string},
        {value: TaskStatus.SENT_TO_FINAL_APPROVAL, label: this.$t('regular.statuses.sentToFinalApprover') as string},
        {value: TaskStatus.WRITETOFILECOMPLETE, label: this.$t('regular.statuses.reportWritten') as string},
        {value: TaskStatus.ERROREXPORT, label: this.$t('regular.statuses.fileWriteError') as string},
        {value: TaskStatus.ERROR, label: this.$t('regular.statuses.noData') as string},
        {value: TaskStatus.PROMONOTRECOMMENDED, label: this.$t('regular.columns.promoNotRecommended') as string},
        {value: TaskStatus.CALCULATING_COMPLETE, label: this.$t('regular.statuses.calcCompleted') as string},
        {value: TaskStatus.CANCELREPORT, label: this.$t('regular.statuses.calcCancelled') as string},
        {value: TaskStatus.EXECUTIONEXCEPTION, label: this.$t('regular.statuses.ctmGapSingularMatrix') as string},
        {value: TaskStatus.APPROVED, label: this.$t('regular.statuses.approved') as string},
        {value: TaskStatus.PARTIALLY_APPROVED, label: this.$t('regular.statuses.partiallyApproved') as string},
    ];

    newTableFields: any[] = [
        {dataIndex: 'selected', scopedSlots: { customRender: 'selected', title: 'selectedTitle' }, fixed: 'left', width: 50},
        {dataIndex: 'taskNote', title: this.$t('regular.columns.notes') as string, scopedSlots: { customRender: 'taskNote', filterDropdown: 'taskNoteFilter', filterIcon: "taskNoteFilterIcon" }, ellipsis: true, width: 150},
        {dataIndex: 'id', title: '№', scopedSlots: { filterDropdown: 'idFilter', filterIcon: "idFilterIcon" }, width: 80},
        {dataIndex: 'message', title: this.$t('regular.columns.status') as string, scopedSlots: { filterDropdown: 'messageFilter', filterIcon: "messageFilterIcon", customRender: 'message' }, ellipsis: true, width: 150},
        {dataIndex: 'updated', title: this.$t('regular.columns.changeTime') as string, customRender: (value: number) => new Date(value).toLocaleString('fr-FR'), scopedSlots: { filterDropdown: 'updatedFilter', filterIcon: "updatedFilterIcon" }, ellipsis: true, width: 150},
        {dataIndex: 'userFio', title: this.$t('regular.columns.user') as string, scopedSlots: { filterDropdown: 'userFioFilter', filterIcon: "userFioFilterIcon" }, ellipsis: true, width: 100},
        {dataIndex: 'progress', title: this.$t('regular.columns.progress') as string, scopedSlots: { customRender: 'progress' }, ellipsis: true, width: 100},
        {dataIndex: 'tradingNetworks.tradingName', title: this.$t('regular.columns.company') as string, scopedSlots: { filterDropdown: 'tradingNameFilter', filterIcon: "tradingNameFilterIcon" }, ellipsis: true, width: 100},
        {dataIndex: 'type', title: this.$t('regular.columns.type') as string, scopedSlots: { customRender: 'type', filterDropdown: 'typeFilter', filterIcon: "typeFilterIcon" }, ellipsis: true, width: 150},
        {dataIndex: 'group', title: this.$t('regular.columns.group') as string, scopedSlots: { filterDropdown: 'groupFilter', filterIcon: "groupFilterIcon" }, ellipsis: true, width: 120},
        {dataIndex: 'category', title: this.$t('regular.columns.category') as string, scopedSlots: { filterDropdown: 'categoryFilter', filterIcon: "categoryFilterIcon" }, ellipsis: true, width: 120},
        {dataIndex: 'subcategories', title: this.$t('regular.columns.subcategories') as string, customRender: (value: string[]) => value.join(', '), scopedSlots: { filterDropdown: 'subcategoriesFilter', filterIcon: "subcategoriesFilterIcon" }, ellipsis: true, width: 120},
        {dataIndex: 'format', title: this.$t('regular.columns.format') as string, scopedSlots: { filterDropdown: 'formatFilter', filterIcon: "formatFilterIcon" }, ellipsis: true, width: 120},
        {dataIndex: 'region', title: this.$t('regular.columns.region') as string, scopedSlots: { filterDropdown: 'regionFilter', filterIcon: "regionFilterIcon" }, ellipsis: true, width: 120},
        {dataIndex: 'cluster', title: this.$t('regular.columns.cluster') as string, scopedSlots: { filterDropdown: 'clusterFilter', filterIcon: "clusterFilterIcon" }, ellipsis: true, width: 120},
    ];

    pagination: any = {
        pageSize: 20,
        current: 1
    };

    timeout: number = 1000;
    lastRequestId: number = 0;

    created() {
        if (this.$disallowedModules.indexOf('promo') !== -1) {
            const index = this.reportList.findIndex((item) => {
                return item.value === TaskType.PROMO;
            });
            if (index !== -1) {
                this.reportList.splice(index, 1);
            }
        }
    }

    mounted() {
        this.loadMarkets();
        if (this.active) {
            this.initLoad();
        }
    }

    beforeDestroy() {
        this.stopPolling();
    }

    @Watch('active')
    onActiveChange(active: boolean) {
        if (active) {
            this.initLoad();
        } else {
            this.stopPolling();
        }
    }

    private stopPolling() {
        clearTimeout(this.refreshTableTimeoutId);
    }

    private initLoad() {
        const pager = { ...this.pagination };
        pager.current = 1;
        this.pagination = pager;
        this.fetchList({
            currentPage: this.pagination.current,
            perPage: this.pagination.pageSize,
        }, () => {});
    }

    onTableChange(pagination: any) {
        const pager = { ...this.pagination };
        pager.current = pagination.current;
        this.pagination = pager;
        this.fetchList({
            currentPage: pagination.current,
            perPage: pagination.pageSize,
        }, () => {});
    }

    showProgressBar(status: string, rtnReportGenerationStatus?: string): boolean {
        return (
            status === 'Calculating'
            || status === 'CalculatingComplete'
            || status === 'WriteToFile'
            || rtnReportGenerationStatus === 'WriteToFile'
        );
    }

    showCancelReportsButton(): boolean {
        return this.selectedReportsArray.length === 0;
    }

    showCompleteMessage(status: string, rtnReportGenerationStatus?: string): boolean {
        return status === 'WriteToFileComplete' && rtnReportGenerationStatus !== 'WriteToFile';
    }

    cancelAllCalculatingReports(reportsArray: number[]) {
        this.httpCancelCalcTask(reportsArray)
                .then((result) => {
                    result.data.forEach((id) => {
                        this.showInfo(this.$t('regular.notifications.reportCancelled') as string + id);
                    });
                    this.handleFilter();
                })
                .catch(() => {
                    this.showError(this.$t('regular.errors.cancelReportFailed') as string);
                });
    }

    fetchList(ctx: any, callback: (items: any[]) => void, isAutoRefresh: boolean = false) {
      const requestId = ++this.lastRequestId;

      if (!isAutoRefresh) {
            this.isTableLoading = true;
            clearTimeout(this.refreshTableTimeoutId);
        }

        const params: TaskParams = {
            size: ctx.perPage, page: ctx.currentPage - 1,
        };

        params.taskIdFilter = this.taskIdFilter
        params.taskNoteFilter = this.taskNoteFilter

        const userFio = this.selectUserFio;
        if (userFio != null && userFio !== 'All') {
            params.userFio = userFio;
        }

        const status = this.selectStatus;
        if (status != null) {
            params.status = status;
        }

        const company = LocalData.zeroToNull(this.selectMarket);
        if (company != null) {
            params.tradingId = company;
        }

        const type = this.selectReportType;
        if (type != null) {
            params.type = type;
        }

        const group = LocalData.zeroToNull(this.selectGroup);
        if (group != null) {
            params.group = group;
        }

        const category = LocalData.zeroToNull(this.categoryOfProduct);
        if (category != null) {
            params.category = category;
        }

        const subCategory = LocalData.filterNumberArrays(this.subCategoryOfProduct, true);
        if (subCategory != null) {
            params.subcategories = subCategory.join(',');
        }

        const storeFormat = LocalData.zeroToNull(this.selectFormat);
        if (storeFormat != null) {
            params.storeFormat = storeFormat;
        }

        const region = LocalData.filterNumberArrays(this.selectRegion, true);
        if (region != null) {
            params.storeRegions = region.join(',');
        }

        const cluster = LocalData.zeroToNull(this.selectCluster);
        if (cluster != null) {
            params.storeCluster = cluster;
        }
        if (this.updatedDateRange.length > 0) {
            params.dateBefore = this.updatedDateRange[0]
            params.dateAfter = this.updatedDateRange[1]
        }
        this.httpGetCalcTaskList(params)
                .then((response) => {
                    if (requestId !== this.lastRequestId) return;

                    const pagination = { ...this.pagination };
                    pagination.total = response.data.totalElements;
                    this.pagination = pagination;
                    this.table = response.data.content;

                    if (!isAutoRefresh && this.table.length === 0) {
                        this.showInfo(this.$t('regular.common.nothingFound') as string)
                    }
                    callback(response.data.content);
                    if (this.active) {
                        this.refreshTableTimeoutId = setTimeout(() => {this.fetchList(ctx, callback, true)}, 10000)
                    }
                })
                .catch((e) => {
                    if (requestId !== this.lastRequestId) return;
                    this.showError(this.$t('regular.errors.loadReportListFailed') as string);
                    callback([]);
                })
                .finally(() => {
                    if (requestId === this.lastRequestId && !isAutoRefresh) {
                        this.isTableLoading = false;
                    }
                });

        if (this.usersFioList.length === 0) {
            this.httpGetUsersFio()
                    .then((response) => {
                        this.usersFioList = response.data.map((i) => {
                            return {value: i, label: i}
                        });
                        this.usersFioList.unshift({value: 'All', label: this.$t('regular.common.all') as string});
                    })
                    .catch((e) => {
                        this.showError(this.$t('regular.errors.loadUserListFailed') as string);
                    });
        }

        this.httpGetAllCalcTaskIds(params)
                .then((response) => {
                  if (requestId !== this.lastRequestId) return;
                  this.allReportsIds = response.data;
                })
                .catch((e) => {
                    if (requestId !== this.lastRequestId) return;
                    this.showError(this.$t('regular.errors.loadReportNumbersFailed') as string);
                });
    }

    selectOrClearAllReports(selected: boolean) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        if (selected) {
          this.isAllReportsSelected = true;
          this.selectedReportsArray = [...this.allReportsIds];
        } else {
          this.isAllReportsSelected = false;
          this.selectedReportsArray = [];
        }
      }, 100);
    }

    isSelectedTaskId(taskId: number) {
        const index = this.selectedReportsArray.findIndex((id) => {
            return id === taskId
        });
        return index !== -1;
    }

    setSelectedTaskId(taskId: number, selected: boolean) {
        const index = this.selectedReportsArray.findIndex((id) => {
            return id === taskId
        });
        if (selected) {
            if (index === -1) {
                this.selectedReportsArray.push(taskId);
            }
        } else {
            if (index !== -1) {
                this.selectedReportsArray.splice(index, 1);
            }
        }
    }

    loadMarkets() {
        this.httpLoadTradingNetworks(true)
                .then((json) => {
                    this.items = json.data
                            .map((item) => {
                                return item;
                            })
                            .sort((a, b) => {
                                return a.id === b.id ? 0 : +(a.id > b.id) || -1;
                            })
                            .map((i) => {
                                return {value: i.id, label: i.tradingName};
                            });

                    this.items = [{
                        value: -1,
                        label: this.$t('regular.common.allTypo') as string,
                    }, ...this.items];
                })
                .catch((err) => {
                });
    }

    clearFilters() {
        this.taskIdFilter = null;
        this.taskIdFilterEdit = null;
        this.selectStatus = null;
        this.selectStatusEdit = null;
        this.selectReportType = null;
        this.selectReportTypeEdit = null;
        this.selectMarket = this.defaultFilterValue.value;
        this.selectMarketEdit = this.defaultFilterValue.value;
        this.selectGroup = this.defaultFilterValue.value;
        this.selectGroupEdit = this.defaultFilterValue.value;
        this.categoryOfProduct = this.defaultFilterValue.value;
        this.categoryOfProductEdit = this.defaultFilterValue.value;
        this.subCategoryOfProduct = [];
        this.subCategoryOfProductEdit = [];
        this.selectFormat = this.defaultFilterValue.value;
        this.selectFormatEdit = this.defaultFilterValue.value;
        this.selectRegion = [];
        this.selectRegionEdit = [];
        this.selectCluster = this.defaultFilterValue.value;
        this.selectClusterEdit = this.defaultFilterValue.value;
        this.categoryOptions = [this.defaultFilterValue];
        this.subCategoryOptions = this.defaultMultipleValue;
        this.formatOptions = this.defaultMultipleValue;
        this.regionOptions = this.defaultMultipleValue;
        this.clusterOptions = this.defaultMultipleValue;
        this.selectUserFio = 'All';
        this.selectUserFioEdit = 'All';
        this.updatedDateRange = [];
        this.updatedDateRangeEdit = [];
        this.taskNoteFilter = null;
        this.taskNoteFilterEdit = null;

        const pager = { ...this.pagination };
        pager.current = 1;
        this.pagination = pager;
        this.fetchList({
            currentPage: this.pagination.current,
            perPage: this.pagination.pageSize,
        }, () => {})
    }

    handleFilter() {
        const pager = { ...this.pagination };
        pager.current = 1;
        this.pagination = pager;
        this.fetchList({
            currentPage: this.pagination.current,
            perPage: this.pagination.pageSize,
        }, () => {})

      if (LocalData.zeroToNull(this.selectMarket) != null) {
        this.loadFilterOptions()
      }
    }

    changeDateRange(dateRange: string[]) {
        this.updatedDateRangeEdit = dateRange;
    }

    applyRegionFilter(confirm: () => void) {
      this.selectRegion = [...this.selectRegionEdit];

      if (this.pagination.current !== 1) {
        this.pagination.current = 1;
      }

      confirm();
      this.updateRegions(this.selectRegion);
      this.fetchList({
        currentPage: this.pagination.current,
        perPage: this.pagination.pageSize,
      }, () => {});
    }

    applySubcategoriesFilter(confirm: () => void) {
      this.subCategoryOfProduct = [...this.subCategoryOfProductEdit];

      if (this.pagination.current !== 1) {
        this.pagination.current = 1;
      }

      confirm();
      this.updateSubcategories(this.subCategoryOfProduct);
      this.fetchList({
        currentPage: this.pagination.current,
        perPage: this.pagination.pageSize,
      }, () => {});
    }

    applyTaskNoteFilter(confirm: () => void) {
      this.taskNoteFilter = this.taskNoteFilterEdit;

      if (this.pagination.current !== 1) {
        this.pagination.current = 1;
      }
      confirm();

      if (LocalData.zeroToNull(this.selectMarket) != null) {
        this.loadFilterOptions();
      }

      this.fetchList({
        currentPage: this.pagination.current,
        perPage: this.pagination.pageSize,
      }, () => {});
    }

    getTaskTypeLabel(typeValue: string): string {
      return localizeTaskType(typeValue);
    }

    getTaskStatusLabel(status: string): string {
      return localizeTaskStatus(status);
    }

    applyReportTypeFilter(confirm: () => void) {
      this.selectReportType = this.selectReportTypeEdit;

      if (this.pagination.current !== 1) {
        this.pagination.current = 1;
      }

      confirm();
      this.fetchList({
        currentPage: this.pagination.current,
        perPage: this.pagination.pageSize,
      }, () => {});
    }

    applyStatusFilter(confirm: () => void) {
      this.selectStatus = this.selectStatusEdit;

      if (this.pagination.current !== 1) {
        this.pagination.current = 1;
      }

      confirm();
      this.fetchList({
        currentPage: this.pagination.current,
        perPage: this.pagination.pageSize,
      }, () => {});
    }

    applyMarketFilter(confirm: () => void) {
      this.selectMarket = this.selectMarketEdit;

      if (this.pagination.current !== 1) {
        this.pagination.current = 1;
      }

      confirm();
      if (LocalData.zeroToNull(this.selectMarket) != null) {
        this.loadFilterOptions();
      }

      this.fetchList({
        currentPage: this.pagination.current,
        perPage: this.pagination.pageSize,
      }, () => {});
    }

    applyUserFioFilter(confirm: () => void) {
      this.selectUserFio = this.selectUserFioEdit;

      if (this.pagination.current !== 1) {
        this.pagination.current = 1;
      }

      confirm();
      this.fetchList({
        currentPage: this.pagination.current,
        perPage: this.pagination.pageSize,
      }, () => {});
    }

    applyGroupFilter(confirm: () => void) {
      this.selectGroup = this.selectGroupEdit;

      if (this.pagination.current !== 1) {
        this.pagination.current = 1;
      }

      confirm();
      this.resetByGroup();
      this.fetchList({
        currentPage: this.pagination.current,
        perPage: this.pagination.pageSize,
      }, () => {});
    }

    applyCategoryFilter(confirm: () => void) {
      this.categoryOfProduct = this.categoryOfProductEdit;

      if (this.pagination.current !== 1) {
        this.pagination.current = 1;
      }

      confirm();
      this.resetByCategory();
      this.fetchList({
        currentPage: this.pagination.current,
        perPage: this.pagination.pageSize,
      }, () => {});
    }

    applyClusterFilter(confirm: () => void) {
      this.selectCluster = this.selectClusterEdit;

      if (this.pagination.current !== 1) {
        this.pagination.current = 1;
      }

      confirm();
      this.resetByStoreCluster();
      this.fetchList({
        currentPage: this.pagination.current,
        perPage: this.pagination.pageSize,
      }, () => {});
    }

    applyFormatFilter(confirm: () => void) {
      this.selectFormat = this.selectFormatEdit;

      if (this.pagination.current !== 1) {
        this.pagination.current = 1;
      }

      confirm();
      this.resetByStoreFormat();
      this.fetchList({
        currentPage: this.pagination.current,
        perPage: this.pagination.pageSize,
      }, () => {});
    }

    applyTaskIdFilter(confirm: () => void) {
      this.taskIdFilter = this.taskIdFilterEdit;

      if (this.pagination.current !== 1) {
        this.pagination.current = 1;
      }

      confirm();
      this.fetchList({
        currentPage: this.pagination.current,
        perPage: this.pagination.pageSize,
      }, () => {});
    }

    applyUpdatedDateRangeFilter(confirm: () => void) {
      this.updatedDateRange = [...this.updatedDateRangeEdit];

      if (this.pagination.current !== 1) {
        this.pagination.current = 1;
      }

      confirm();
      this.fetchList({
        currentPage: this.pagination.current,
        perPage: this.pagination.pageSize,
      }, () => {});
    }

  async loadFilterOptions() {
          try {
            await Promise.all([
              this.getGroupInfo(),
              this.getCategoryInfo(),
              this.getSubcategoryInfo(),
              this.getStoreFormatsInfo(),
              this.getStoreRegionsInfo(),
              this.getStoreClustersInfo(),
            ]);
          } catch (e) {
          }
        }

    onFilterButtonClick() {
        this.handleFilter();
        this.selectOrClearAllReports(this.isAllReportsSelected);
    }

    resetByGroup() {
        this.resetData(TaskInfoFilterType.group)
    }

    resetByCategory() {
        this.resetData(TaskInfoFilterType.category)
    }

    resetByStoreFormat() {
        this.resetData(TaskInfoFilterType.format)
    }

    resetByStoreCluster() {
        this.resetData(TaskInfoFilterType.cluster)
    }

    updateSubcategories(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.subCategoryOfProduct)) {
            this.subCategoryOfProduct = list;
            this.resetBySubcategory();
        } else if (this.subCategoryOfProduct[0] === 0) {
            this.subCategoryOfProduct = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateRegions(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.selectRegion)) {
            this.selectRegion = list;
            this.resetByStoreRegion();
        } else if (this.selectRegion[0] === 0) {
            this.selectRegion = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    taskIdPrevent(e: any) {
        if (e.key === 'Backspace' || e.key === 'Delete' || e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
            return
        }
        if (!/^\d+$/.test(e.key)) {
            e.preventDefault();
        }
    }

    private getTaskInfo(taskType: TaskInfoFilterType): GetTaskInfo {
        return {
            type: taskType,
            // tslint:disable-next-line: no-non-null-assertion
            tradingId: this.selectMarket!!,
            categories: LocalData.filterNumberArrays([this.categoryOfProduct], true),
            groups: LocalData.filterNumberArrays([this.selectGroup], true),
            subcategory: LocalData.filterNumberArrays(this.subCategoryOfProduct, true),
            segments: null,
            storeFormat: LocalData.filterNumberArrays([this.selectFormat], true),
            storeCluster: LocalData.filterNumberArrays([this.selectCluster], true),
            storeRegion: LocalData.filterNumberArrays(this.selectRegion, true),
            byReports: true,
        }
    }

    private resetBySubcategory() {
        this.resetData(TaskInfoFilterType.subcategory)
    }

    private resetByStoreRegion() {
        this.resetData(TaskInfoFilterType.region)
    }

    private resetData(type: TaskInfoFilterType | null = null) {
        switch (type) {
            case null:
                this.selectGroup = this.defaultFilterValue.value;
                this.categoryOfProduct = this.defaultFilterValue.value;
                this.subCategoryOfProduct = [];
                this.selectFormat = this.defaultFilterValue.value;
                this.selectRegion = [];
                this.selectCluster = this.defaultFilterValue.value;
                this.groupOptions = this.defaultMultipleValue;
                this.categoryOptions = [this.defaultFilterValue];
                this.subCategoryOptions = this.defaultMultipleValue;
                this.formatOptions = this.defaultMultipleValue;
                this.regionOptions = this.defaultMultipleValue;
                this.clusterOptions = this.defaultMultipleValue;
                break;
            case TaskInfoFilterType.group:
                this.categoryOfProduct = this.defaultFilterValue.value;
                this.subCategoryOfProduct = [];
                this.selectFormat = this.defaultFilterValue.value;
                this.selectRegion = [];
                this.selectCluster = this.defaultFilterValue.value;
                this.categoryOptions = [this.defaultFilterValue];
                this.subCategoryOptions = this.defaultMultipleValue;
                this.formatOptions = this.defaultMultipleValue;
                this.regionOptions = this.defaultMultipleValue;
                this.clusterOptions = this.defaultMultipleValue;
                Promise.all([
                  this.getCategoryInfo(),
                  this.getSubcategoryInfo(),
                  this.getStoreFormatsInfo(),
                  this.getStoreRegionsInfo(),
                  this.getStoreClustersInfo()
                ]);
                break;
            case TaskInfoFilterType.category:
                this.subCategoryOfProduct = [];
                this.selectFormat = this.defaultFilterValue.value;
                this.selectRegion = [];
                this.selectCluster = this.defaultFilterValue.value;
                this.subCategoryOptions = this.defaultMultipleValue;
                this.formatOptions = this.defaultMultipleValue;
                this.regionOptions = this.defaultMultipleValue;
                this.clusterOptions = this.defaultMultipleValue;
                Promise.all([
                  this.getSubcategoryInfo(),
                  this.getStoreFormatsInfo(),
                  this.getStoreRegionsInfo(),
                  this.getStoreClustersInfo()
                ]);
                break;
            case TaskInfoFilterType.subcategory:
                this.selectFormat = this.defaultFilterValue.value;
                this.selectRegion = [];
                this.selectCluster = this.defaultFilterValue.value;
                this.formatOptions = this.defaultMultipleValue;
                this.regionOptions = this.defaultMultipleValue;
                this.clusterOptions = this.defaultMultipleValue;
                Promise.all([
                  this.getStoreFormatsInfo(),
                  this.getStoreRegionsInfo(),
                  this.getStoreClustersInfo()
                ]);
                break;
            case TaskInfoFilterType.format:
                this.selectRegion = [];
                this.selectCluster = this.defaultFilterValue.value;
                this.regionOptions = this.defaultMultipleValue;
                this.clusterOptions = this.defaultMultipleValue;
                Promise.all([
                  this.getStoreRegionsInfo(),
                  this.getStoreClustersInfo()
                ]);
                break;
            case TaskInfoFilterType.region:
                this.selectCluster = this.defaultFilterValue.value;
                this.clusterOptions = this.defaultMultipleValue;
                this.getStoreClustersInfo();
                break;
        }
    }

    private getGroupInfo() {
        return this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.group))
                .then((data) => {
                    const filterData = data.data;
                    this.groupOptions = filterData.groups.map((i) => {
                        return {value: i.id, label: i.name}
                    });
                    this.groupOptions.unshift(this.defaultFilterValue, this.secondDefaultFilterValue);
                })
                .catch((e) => {
                })
    }

    private getCategoryInfo() {
        return this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.category))
                .then((data) => {
                    const filterData = data.data;
                    this.categoryOptions = filterData.categories.map((i) => {
                        return {value: i.id, label: i.name}
                    });
                    this.categoryOptions.unshift(this.defaultFilterValue);
                })
                .catch((e) => {
                })
    }

    private getSubcategoryInfo() {
       return this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.subcategory))
                .then((data) => {
                    const filterData = data.data;
                    this.subCategoryOptions = filterData.subcategories.map((i) => {
                        return {value: i.id, label: i.name}
                    });
                    this.subCategoryOptions.unshift(this.defaultFilterValue, this.secondDefaultFilterValue)
                })
                .catch((e) => {
                })
    }

    private getStoreFormatsInfo() {
       return this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.format))
                .then((data) => {
                    const filterData = data.data;
                    this.formatOptions = filterData.storeFormat.map((i) => {
                        return {value: i.id, label: i.name}
                    });
                    this.formatOptions.unshift(this.defaultFilterValue, this.secondDefaultFilterValue)
                })
                .catch((e) => {
                })
    }

    private getStoreRegionsInfo() {
       return this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.region))
                .then((data) => {
                    const filterData = data.data;
                    this.regionOptions = filterData.storeRegion.map((i) => {
                        return {value: i.id, label: i.name}
                    });
                    this.regionOptions.unshift(this.defaultFilterValue, this.secondDefaultFilterValue)
                })
                .catch((e) => {
                })
    }

    private getStoreClustersInfo() {
        return this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.cluster))
                .then((data) => {
                    const filterData = data.data;
                    this.clusterOptions = filterData.storeCluster.map((i) => {
                        return {value: i.id, label: i.name}
                    }, this.secondDefaultFilterValue);
                    this.clusterOptions.unshift(this.defaultFilterValue, this.secondDefaultFilterValue)
                })
                .catch((e) => {
                })
    }

    private isFilterDisabled(): boolean {
      const market = this.selectMarket;
      return LocalData.zeroToNull(market) == null;
    }
}
